require('@popperjs/core');
require('bootstrap');
require('./technicals');
require('select2');

require('./legacy/jquery.easing.1.3.js');
require('./legacy/jquery.waypoints.min.js');
// require('./legacy/jquery.stellar.min.js');
require('stellar.js');
require('./legacy/owl.carousel.min.js');
require('./legacy/jquery.magnific-popup.min.js');
require('./legacy/jquery.animateNumber.min.js');
require('./legacy/scrollax.min.js');
require('./legacy/main.js');
require('./form.js');

require('lightbox2');
require('imagesloaded');

import Inputmask from "inputmask";

$(document).ready(function () {
    let selector = document.querySelectorAll(".mask-email");
    Inputmask({alias: "email"}).mask(selector);

    const name = [105, 110, 102, 111]; // ASCII char codes for 'info'
    const domain = [122, 106, 97, 122, 100, 102, 98, 108, 114]; // ASCII char codes for 'zjazdfblr'
    const tld = [115, 107]; // ASCII char codes for 'sk'
    const emailChars = name.concat(64, domain, 46, tld); // In ASCII, 64 is '@', and 46 is '.'
    const email = emailChars.map(function (char) {
        return String.fromCharCode(char);
    }).join("");

    $(".contact-email").attr("href", "mailto:" + email).text(email);
});
global.Masonry = window.Masonry = require('masonry-layout');

$(window).on('load', function () {
    if ($('#gallery-photos').length !== 0) {
        let masonryGrid = new Masonry('#gallery-photos', {percentPosition: false});

        $(window).on('load', function () {
            masonryGrid.layout();
        });

        $('#gallery-photos img').imagesLoaded().progress(function () {
            masonryGrid.layout();
        });
    }
});